import { render, staticRenderFns } from "./returnBoxDialog.vue?vue&type=template&id=5cff63ac&"
import script from "./returnBoxDialog.vue?vue&type=script&lang=js&"
export * from "./returnBoxDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cff63ac')) {
      api.createRecord('5cff63ac', component.options)
    } else {
      api.reload('5cff63ac', component.options)
    }
    module.hot.accept("./returnBoxDialog.vue?vue&type=template&id=5cff63ac&", function () {
      api.rerender('5cff63ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/RailwayExport/components/booking/returnBoxDialog.vue"
export default component.exports